import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AdminManagement = () => {
  const [admins, setAdmins] = useState([]);
  const [search, setSearch] = useState('');
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [editAdmin, setEditAdmin] = useState(null);
  const [editForm, setEditForm] = useState({ email: '', password: '', name: '' });

  const loadAdmins = async (searchTerm = '') => {
    const res = await axios.get(`${API_BASE_URL}/admins`, { params: { search: searchTerm } });
    setAdmins(res.data);
  };

  useEffect(() => { loadAdmins(); }, []);

  const handleSearch = e => {
    setSearch(e.target.value);
    loadAdmins(e.target.value);
  };

  const handleAddAdmin = async e => {
    e.preventDefault();
    await axios.post(`${API_BASE_URL}/admins`, form);
    setForm({ email: '', password: '', name: '' });
    loadAdmins(search);
  };

  const handleDeleteAdmin = async (email) => {
    await axios.delete(`${API_BASE_URL}/admins/${email}`);
    loadAdmins(search);
  };

  const handleEditClick = (admin) => {
    setEditAdmin(admin.email);
    setEditForm({ email: admin.email, password: admin.password, name: admin.name });
  };

  const handleEditSave = async () => {
    await axios.put(`${API_BASE_URL}/admins/${editAdmin}`, editForm);
    setEditAdmin(null);
    loadAdmins(search);
  };

  return (
    <div>
      <h3 className="text-xl font-bold mb-4">Admin Management</h3>
      <form className="mb-4 flex gap-2" onSubmit={handleAddAdmin}>
        <input name="name" type="text" placeholder="Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
        <input name="email" type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
        <input name="password" type="text" placeholder="Password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
        <button className="bg-green-600 text-white px-4 py-1 rounded" type="submit">Add Admin</button>
      </form>
      <input className="border px-2 py-1 mb-4" placeholder="Search by email" value={search} onChange={handleSearch} />
      <table className="min-w-full bg-white rounded shadow">
        <thead>
          <tr>
            <th className="px-4 py-2">Name</th>
            <th>Email</th>
            <th>Password</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {admins.map(admin => (
            <tr key={admin.email}>
              {editAdmin === admin.email ? (
                <>
                  <td><input value={editForm.name} onChange={e => setEditForm({ ...editForm, name: e.target.value })} /></td>
                  <td><input value={editForm.email} onChange={e => setEditForm({ ...editForm, email: e.target.value })} /></td>
                  <td><input value={editForm.password} onChange={e => setEditForm({ ...editForm, password: e.target.value })} /></td>
                  <td>
                    <button className="bg-blue-600 text-white px-2 py-1 rounded" onClick={handleEditSave}>Save</button>
                    <button className="bg-gray-400 text-white px-2 py-1 rounded ml-2" onClick={() => setEditAdmin(null)}>Cancel</button>
                  </td>
                </>
              ) : (
                <>
                  <td>{admin.name}</td>
                  <td>{admin.email}</td>
                  <td>{admin.password}</td>
                  <td>
                    <button className="bg-yellow-600 text-white px-2 py-1 rounded" onClick={() => handleEditClick(admin)}>Edit</button>
                    <button className="bg-red-600 text-white px-2 py-1 rounded ml-2" onClick={() => handleDeleteAdmin(admin.email)}>Delete</button>
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminManagement;